document.addEventListener("DOMContentLoaded", function () {
  if (!window.jQuery) return;
  jQuery(function ($) {
    $(".swatch :radio").change(function () {
      var optionIndex = $(this).closest(".swatch").attr("data-option-index");
      var optionValue = $(this).val();
      var sku = $(this).data("sku");
      $(this)
        .closest("form")
        .find(".single-option-selector")
        .eq(optionIndex)
        .val(optionValue)
        .trigger("change");

      $(this).parents(".watch_availabel").find("span.variant_current").text(optionValue);
      $(".template-product .variant-sku").text(sku);
    });
  });
});
